export class FinishInfoResponse {
    public hasTaxLiability: boolean;
    public planTaxSaving: number;
    public providerCharges: Array<ProviderChargeResponse>;

    constructor(hasTaxLiability: boolean, planTaxSaving: number, providerCharges: Array<ProviderChargeResponse>) {
        this.hasTaxLiability = hasTaxLiability;
        this.planTaxSaving = planTaxSaving;
        this.providerCharges = providerCharges;
    }

    public getIndustryAverageChargeResponse(): ProviderChargeResponse {
        if (this.providerCharges == null) {
            return { name: "IndustryAverageCharges", charge: 0 } as ProviderChargeResponse;
        }

        const industryAvg = this.providerCharges.find(pcr => pcr.name == "IndustryAverageCharges");

        if (industryAvg == undefined) {
            return { name: "IndustryAverageCharges", charge: 0 } as ProviderChargeResponse;
        }

        return industryAvg;
    }
}

export interface ProviderChargeResponse {
    name: string;
    charge: number;
}
